import { type Control, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Box, Divider } from '@mui/material';
import EvStationIcon from '@mui/icons-material/EvStation';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type EvChargersDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const EvChargersDetails = ({ control }: EvChargersDetailsProps) => {
  const { general: { evChargers } = {} } = useWatch({ control });

  const items = [
    {
      label: 'Count',
      value: isNil(evChargers?.count) ? undefined : String(evChargers!.count),
    },
    { label: 'Location', value: evChargers?.location },
    {
      label: 'Fed by house meter',
      value: isNil(evChargers?.isFedByHouseMeter)
        ? undefined
        : evChargers!.isFedByHouseMeter
          ? 'Yes'
          : 'No',
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <EvStationIcon fontSize="inherit" />
            <span>&nbsp;EV Chargers</span>
          </Grid>
        </Typography>
        {items.map(({ label, value }) => (
          <Grid key={label} container justifyContent="space-between">
            <Typography component="span" variant="body2">
              {label}:
            </Typography>
            <Typography
              component="span"
              variant="body2"
              color={isNil(value) ? 'textDisabled' : 'textPrimary'}>
              {value ?? '—'}
            </Typography>
          </Grid>
        ))}
        <Divider />
      </Stack>
    </Box>
  );
};
